export default __webpack_public_path__ + "static/media/GetReadyPersona.1bc9787c.png";